/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Table, Spin, message, Card, Row, Col, Typography } from "antd";
import { useLocation } from "react-router-dom";

import API from "../../../api";
import urls from "../../../api/urls";
import moment from "moment";
import Heading from "../../../components/Heading";

const { Text } = Typography;
const {
  DRS_DELIVERED_CLICKABLE,
  DRS_RTO_DELIVERED_CLICKABLE,
  DRS_POD_UPDATED_CLICKABLE,
  DRS_POD_PENDING_CLICKABLE,
  DRS_UNDELIVERED_CLICKABLE,
  DRS_RTO_UNDELIVERED_CLICKABLE,
  DRS_STATUS_UPDATE_PENDING_CLICKABLE,
  DRS_RTO_INITIATED_CLICKABLE,
  DRS_TOTAL_SHIPMENTS_CLICKABLE,
  DRS_SAME_DAY_DELIVERED_CLICKABLE,
  DRS_SAME_DAY_RTO_DELIVERED_CLICKABLE,
  DEL_MIS_OUTSCAN_TO_CP_CLICKABLE,
  DEL_MIS_INSCAN_SAME_DAY_CLICKABLE,
  DEL_MIS_NOT_SAME_DAY_INSCAN_CLICKABLE,
  DEL_MIS_SAME_DAY_OFD_CLICKABLE,
  DEL_MIS_SAME_DAY_DELIVERED_CLICKABLE,
  DEL_MIS_SAME_DAY_UNDELIVERED_CLICKABLE,
  DEL_MIS_SAME_DAY_RTO_OFD_CLICKABLE,
  DEL_MIS_SAME_DAY_RTO_INITIATED_CLICKABLE,
  DEL_MIS_SAME_DAY_RTO_DELIVERED_CLICKABLE,
  DEL_MIS_SAME_DAY_RTO_UNDELIVERED_CLICKABLE,
  HOCI_OUTSCAN_TO_CP_CLICKABLE,
  HOCI_INSCAN_BY_SAME_CP_CLICKABLE,
  HOCI_INSCAN_BY_OTHER_CP_CLICKABLE,
  HOCI_OUTSCAN_BY_HUB_DETAIL,
  HOCI_INSCAN_SAME_CP_DETAIL,
  HOCI_INSCAN_OTHER_CP_DETAIL,
  HOCI_NOT_INSCANNED_DETAIL,
  DEL_MIS_NEW_NDD_CLICKABLE,
  DEL_MIS_NEW_NDD_PLUS_1_CLICKABLE,
  DEL_MIS_NEW_NDD_PLUS_2_CLICKABLE,
  DEL_MIS_NEW_NDD_PLUS_3_CLICKABLE,
  DEL_MIS_NEW_NDD_PLUS_4_CLICKABLE,
  DEL_MIS_NEW_NDD_GREATER_4_CLICKABLE,
} = urls;

const DRSClickableDetail = () => {
  const location = useLocation();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [pageNum, setPageNum] = useState(1);
  const [columns, setColumns] = useState([]);

  const searchParams = new URLSearchParams(location.search);
  const drsNumber = searchParams.get("drsNumber");
  const type = searchParams.get("type");

  useEffect(() => {
    if (type) {
      fetchDetails(pageNum, pageSize);
    }
  }, [type, pageNum, pageSize]);

  const fetchDetails = async (page, size) => {
    setLoading(true);
    try {
      let baseUrl = "";
      let token = "";

      if (type === "delivered") {
        baseUrl = DRS_DELIVERED_CLICKABLE;
        token =
          "ba250e628e5c070cf679f5d63ea117078c013ad3bbb79fefe1e187a071e78e35";
      } else if (type === "rto-delivered") {
        baseUrl = DRS_RTO_DELIVERED_CLICKABLE;
        token =
          "c19bd253d17e6b6aaf7d7c2f1224cc0921c39c4b4cdb6425039cb70efcfba57f";
      } else if (type === "pod-updated") {
        baseUrl = DRS_POD_UPDATED_CLICKABLE;
        token =
          "67caaf8e161d5721d03d76856a94cb18f2b854da296ec634ca771a775a8f6d4f";
      } else if (type === "pod-pending") {
        baseUrl = DRS_POD_PENDING_CLICKABLE;
        token =
          "54fb10194fc7c9ce087cce37905b8e0c3484fafe8974ddf6a264546685f54548";
      } else if (type === "undelivered") {
        baseUrl = DRS_UNDELIVERED_CLICKABLE;
        token =
          "e2f716a9a002c5ae7714871d011068fbfc5cc76af834fe13c418883fe193be21";
      } else if (type === "rto-undelivered") {
        baseUrl = DRS_RTO_UNDELIVERED_CLICKABLE;
        token =
          "b4aaadeb413dc72d99913f8b165f110d872fa5beb0fa979bb36884f39bb50c64";
      } else if (type === "status-pending") {
        baseUrl = DRS_STATUS_UPDATE_PENDING_CLICKABLE;
        token =
          "f261c5d4b376655dd986ded96d8e5e99ec95605d5397ab6697fa052d0cbbc623";
      } else if (type === "rto-initiated") {
        baseUrl = DRS_RTO_INITIATED_CLICKABLE;
        token =
          "c0fff34ac71d236c321db03ae43eba98a36de1440c46869f7e331e435ca9be61";
      } else if (type === "total-shipments") {
        baseUrl = DRS_TOTAL_SHIPMENTS_CLICKABLE;
        token =
          "7d000bdbd03de906c10b6cfb09eec89dadf740ff9bbd68db9b01f7dd12996fe5";
      } else if (type === "same-day-delivered") {
        baseUrl = DRS_SAME_DAY_DELIVERED_CLICKABLE;
        token =
          "ef9b5d6f60f0704b986609930c1f31770e51e202fd4e654569bb3e6953fd6e95";
      } else if (type === "same-day-rto-delivered") {
        baseUrl = DRS_SAME_DAY_RTO_DELIVERED_CLICKABLE;
        token =
          "2c28c490f68cfae9b42ca3a656bce5b7055ce02c3aac1c7777925c560e732edc";
      } else if (type === "mis-outscan") {
        baseUrl = DEL_MIS_OUTSCAN_TO_CP_CLICKABLE;
        token =
          "a3b1279946fdae89b09fb2bc1071d08b032996d322984209832f7b35e1202a0f";
      } else if (type === "mis-inscan-same-day") {
        baseUrl = DEL_MIS_INSCAN_SAME_DAY_CLICKABLE;
        token =
          "f357cb04963d0590fcb2af2c2136c7a396c18485b578fa9f2e6aaae9c91e5cf1";
      } else if (type === "mis-not-inscan-same-day") {
        baseUrl = DEL_MIS_NOT_SAME_DAY_INSCAN_CLICKABLE;
        token =
          "cb6caa31ca72c5fa6bdb969f83acc73e9086a20a2c9aa130fe4ea542a5103454";
      } else if (type === "mis-ofd-same-day") {
        baseUrl = DEL_MIS_SAME_DAY_OFD_CLICKABLE;
        token =
          "9e3413e9a1e01a2552dd67a4cac033ce3dda2ce3bc0c32d18a55fbfb97a60e7d";
      } else if (type === "mis-delivered-same-day") {
        baseUrl = DEL_MIS_SAME_DAY_DELIVERED_CLICKABLE;
        token =
          "e954f371a5d09c035af6b27d2ea34f2717daf05ec476674ee638398c040e766e";
      } else if (type === "mis-undelivered-same-day") {
        baseUrl = DEL_MIS_SAME_DAY_UNDELIVERED_CLICKABLE;
        token =
          "b19faef7c08fb702022595326bf82c41a6d4e100cf800af8d8e27a102ac13737";
      } else if (type === "mis-rto-ofd-same-day") {
        baseUrl = DEL_MIS_SAME_DAY_RTO_OFD_CLICKABLE;
        token =
          "0fdc884eb8aee7a6fd5eb6043b4d3debc7f51e7d85b38913a1f08d65c862a662";
      } else if (type === "mis-rto-initiated-same-day") {
        baseUrl = DEL_MIS_SAME_DAY_RTO_INITIATED_CLICKABLE;
        token =
          "2a6fef9dc9e27119ce3a4cc458ba36c58c7952a5d1cced2f05c1709a28f02c00";
      } else if (type === "mis-rto-delivered-same-day") {
        baseUrl = DEL_MIS_SAME_DAY_RTO_DELIVERED_CLICKABLE;
        token =
          "2efae63d71047b04836c2bbc9b7d17dff6ead9925746312fc4451c629c58b042";
      } else if (type === "mis-rto-undelivered-same-day") {
        baseUrl = DEL_MIS_SAME_DAY_RTO_UNDELIVERED_CLICKABLE;
        token =
          "591badb9c2d445a309ea1b310b42790bb841c42b6237b42e46f37e13dcced305";
      } else if (type === "hoci-outscan") {
        baseUrl = HOCI_OUTSCAN_TO_CP_CLICKABLE;
        token =
          "db63076deeb5a4f515b75959e7a66a23509dc0b3a56ee6b628008e01a473582c";
      } else if (type === "hoci-inscan-same") {
        baseUrl = HOCI_INSCAN_BY_SAME_CP_CLICKABLE;
        token =
          "23edcfee9b527258313f9a7c816f99a8022d3a1c5880ad520d7d349dd876e87a";
      } else if (type === "hoci-inscan-other") {
        baseUrl = HOCI_INSCAN_BY_OTHER_CP_CLICKABLE;
        token =
          "0539d89465e13f46860161dea5ff419e8808a3784d2549382e5a7b3e3e9f9f27";
      } else if (type === "hoci-v2-outscan") {
        baseUrl = HOCI_OUTSCAN_BY_HUB_DETAIL;
      } else if (type === "hoci-v2-inscan-same") {
        baseUrl = HOCI_INSCAN_SAME_CP_DETAIL;
      } else if (type === "hoci-v2-inscan-other") {
        baseUrl = HOCI_INSCAN_OTHER_CP_DETAIL;
      } else if (type === "hoci-v2-not-inscanned") {
        baseUrl = HOCI_NOT_INSCANNED_DETAIL;
      } else if (type === "mis-new-ndd") {
        baseUrl = DEL_MIS_NEW_NDD_CLICKABLE;
        token = "b9a70e0490cafa5f26f378739c01ec7b07c33be8a0761c0deee01e7b8c5c2e74";
      } else if (type === "mis-new-ndd-1") {
        baseUrl = DEL_MIS_NEW_NDD_PLUS_1_CLICKABLE;
        token = "e6d43ab3b83b96c91ee80f9b3ad54e343c59567ca839ed24403f76fb22b01d7e";
      } else if (type === "mis-new-ndd-2") {
        baseUrl = DEL_MIS_NEW_NDD_PLUS_2_CLICKABLE;
        token = "ffe2311f1bc1020bfadaaab4f6271c5b79457c363bddc213cbcffe2dc1e49113";
      } else if (type === "mis-new-ndd-3") {
        baseUrl = DEL_MIS_NEW_NDD_PLUS_3_CLICKABLE;
        token = "94e06f964118e454bebe4e1e01d12a75b6958ab6ad07c2f7f4fbe95fc27774ed";
      } else if (type === "mis-new-ndd-4") {
        baseUrl = DEL_MIS_NEW_NDD_PLUS_4_CLICKABLE;
        token = "d58de980f5504544b61465284bfa495a23070e023e351857b3778d0977e08b1d";
      } else if (type === "mis-new-ndd-4-plus") {
        baseUrl = DEL_MIS_NEW_NDD_GREATER_4_CLICKABLE;
        token = "ae059df784922778562fcd46a0daefe58623244a817104bfc8229999c154ccab";
      }

      const paramsForUrl = new URLSearchParams(location.search);
      const drsNum = paramsForUrl.get("drsNumber");
      const createdDate = paramsForUrl.get("drsCreatedDate");
      const fromDate_outscan_date = paramsForUrl.get("fromDate_outscan_date");
      const toDate_outscan_date = paramsForUrl.get("toDate_outscan_date");
      const from_hub_id = paramsForUrl.get("from_hub_id");
      const to_channel_partner = paramsForUrl.get("to_channel_partner");

      paramsForUrl.delete("type");
      paramsForUrl.delete("drsNumber");
      paramsForUrl.delete("drsCreatedDate");
      paramsForUrl.delete("fromDate_outscan_date");
      paramsForUrl.delete("toDate_outscan_date");
      paramsForUrl.delete("from_hub_id");
      paramsForUrl.delete("to_channel_partner");

      const isHociV2 = type.startsWith("hoci-v2-");

      if (isHociV2) {
        paramsForUrl.set("date", searchParams.get("date"));
        paramsForUrl.set("fromHubId", searchParams.get("fromHubId"));
        paramsForUrl.set("cpId", searchParams.get("cpId"));
      } else if (type.startsWith("mis-")) {
        paramsForUrl.set("fromDate_outscan_date", fromDate_outscan_date);
        paramsForUrl.set("toDate_outscan_date", toDate_outscan_date);
        paramsForUrl.set("from_hub_id", from_hub_id);
        paramsForUrl.set("to_channel_partner", to_channel_partner);
      } else if (type.startsWith("hoci-")) {
        paramsForUrl.set("fromDate_date", fromDate_outscan_date);
        paramsForUrl.set("toDate_date", toDate_outscan_date);
        paramsForUrl.set("from_hub_id", from_hub_id);
        paramsForUrl.set("cp_id", searchParams.get("cp_id"));
      } else {
        paramsForUrl.set("new_drs_number", drsNum);
        paramsForUrl.set("fromDate_drs_created_date", createdDate);
        paramsForUrl.set("toDate_drs_created_date", createdDate);
      }

      paramsForUrl.set("page", isHociV2 ? page - 1 : page);
      paramsForUrl.set("size", size);

      const url = `${baseUrl}?${paramsForUrl.toString()}`;

      let result;
      if (isHociV2) {
        result = await API.Api(url).get();
      } else {
        const payload = type.startsWith("hoci-")
          ? {
              user_name: "shriraj_bhosale",
              user_email: "shriraj.bhosale@shreemaruti.com",
            }
          : {
              user_name: "laxminandan",
              user_email: "laxminandan.handique@shreemaruti.com",
            };
        result = await API.Api(url).postCustomHeader(payload, {
          Authorization: `Bearer ${token}`,
        });
      }

      const response = result?.response?.data;
      const isSuccess = isHociV2
        ? result?.status && Array.isArray(response?.data)
        : response?.success;

      if (isSuccess) {
        setTableData(response.data || []);
        setTotal(
          isHociV2
            ? response.pagination?.totalRecords || 0
            : response.total_records || 0,
        );
        if (!isHociV2 && response.pagination) {
          setPageNum(response.pagination.page);
          setPageSize(response.pagination.size);
        }

        if (response.data && response.data.length > 0) {
          const dynamicColumns = Object.keys(response.data[0]).map((key) => ({
            title: key
              .split("_")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" "),
            dataIndex: key,
            key: key,
            render: (text) => {
              if (
                key.toLowerCase().includes("at") ||
                key.toLowerCase().includes("date")
              ) {
                // Check if text is a valid long date string
                return text && moment(text).isValid()
                  ? moment(text).format("DD-MM-YYYY HH:mm")
                  : text || "-";
              }
              return text === 0 ? 0 : text || "-";
            },
          }));
          setColumns(dynamicColumns);
        }
      } else {
        setTableData([]);
        setTotal(0);
        message.error(response?.message || "Failed to fetch details");
      }
    } catch (error) {
      console.error("Error fetching DRS clickable details:", error);
      message.error("Error fetching data");
      setTableData([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (pagination) => {
    setPageNum(pagination.current);
    setPageSize(pagination.pageSize);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const getTitle = () => {
    switch (type) {
      case "delivered":
        return "Delivered Details";
      case "rto-delivered":
        return "RTO Delivered Details";
      case "pod-updated":
        return "POD Updated Details";
      case "pod-pending":
        return "POD Update Pending Details";
      case "undelivered":
        return "Undelivered Details";
      case "rto-undelivered":
        return "RTO Undelivered Details";
      case "status-pending":
        return "Status Update Pending Details";
      case "rto-initiated":
        return "RTO Initiated Details";
      case "total-shipments":
        return "Total Shipments Details";
      case "same-day-delivered":
        return "Same Day Delivered Details";
      case "same-day-rto-delivered":
        return "Same Day RTO Delivered Details";
      case "mis-outscan":
        return "Shipments Outscanned Details";
      case "mis-inscan-same-day":
        return "Inscan Same Day Details";
      case "mis-not-inscan-same-day":
        return "Not Inscan Same Day Details";
      case "mis-ofd-same-day":
        return "OFD Same Day Details";
      case "mis-delivered-same-day":
        return "Delivered Same Day Details";
      case "mis-undelivered-same-day":
        return "Undelivered Same Day Details";
      case "mis-rto-ofd-same-day":
        return "RTO OFD Same Day Details";
      case "mis-rto-initiated-same-day":
        return "RTO Initiated Same Day Details";
      case "mis-rto-delivered-same-day":
        return "RTO Delivered Same Day Details";
      case "mis-rto-undelivered-same-day":
        return "RTO Undelivered Same Day Details";
      case "hoci-outscan":
        return "Outscan to CP Details";
      case "hoci-inscan-same":
        return "Inscan by Same CP Details";
      case "hoci-inscan-other":
        return "Inscan by Other CP Details";
      case "hoci-v2-outscan":
        return "Outscan by Hub to CP Details";
      case "hoci-v2-inscan-same":
        return "Inscanned by Same CP Details";
      case "hoci-v2-inscan-other":
        return "Inscanned by Other CP Details";
      case "hoci-v2-not-inscanned":
        return "Not Inscanned by CP Details";
      case "mis-new-ndd":
        return "NDD Details";
      case "mis-new-ndd-1":
        return "NDD+1 Details";
      case "mis-new-ndd-2":
        return "NDD+2 Details";
      case "mis-new-ndd-3":
        return "NDD+3 Details";
      case "mis-new-ndd-4":
        return "NDD+4 Details";
      case "mis-new-ndd-4-plus":
        return "NDD+4++ Details";
      default:
        return "Details";
    }
  };

  return (
    <Spin spinning={loading}>
      <div style={{ padding: "10px" }}>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: "16px" }}
        >
          <Heading
            title={getTitle()}
            backButtonClick={() => {
              if (window.history.length > 1) {
                window.history.back();
              } else {
                window.close();
              }
            }}
          />
        </Row>

        {type && !type.startsWith("mis-") && !type.startsWith("hoci-") && (
          <Card style={{ marginBottom: "16px" }}>
            <Row gutter={24}>
              <Col>
                <Text strong>DRS Number: </Text>
                <Text>{drsNumber}</Text>
              </Col>
              {searchParams.get("drsCreatedDate") && (
                <Col>
                  <Text strong>DRS Creation Date: </Text>
                  <Text>{searchParams.get("drsCreatedDate")}</Text>
                </Col>
              )}
            </Row>
          </Card>
        )}

        {type && type.startsWith("mis-") && (
          <Card style={{ marginBottom: "16px" }}>
            <Row gutter={24}>
              <Col>
                <Text strong>Hub: </Text>
                <Text>{searchParams.get("from_hub_id")}</Text>
              </Col>
              <Col>
                <Text strong>Channel Partner: </Text>
                <Text>{searchParams.get("to_channel_partner")}</Text>
              </Col>
              <Col>
                <Text strong>Date: </Text>
                <Text>{searchParams.get("fromDate_outscan_date")}</Text>
              </Col>
            </Row>
          </Card>
        )}

        {type && type.startsWith("hoci-") && !type.startsWith("hoci-v2-") && (
          <Card style={{ marginBottom: "16px" }}>
            <Row gutter={24}>
              <Col>
                <Text strong>Hub: </Text>
                <Text>{searchParams.get("from_hub_id")}</Text>
              </Col>
              <Col>
                <Text strong>CP ID: </Text>
                <Text>{searchParams.get("cp_id")}</Text>
              </Col>
              <Col>
                <Text strong>Date: </Text>
                <Text>{searchParams.get("fromDate_outscan_date")}</Text>
              </Col>
            </Row>
          </Card>
        )}

        {type && type.startsWith("hoci-v2-") && (
          <Card style={{ marginBottom: "16px" }}>
            <Row gutter={24}>
              <Col>
                <Text strong>Hub ID: </Text>
                <Text>{searchParams.get("fromHubId")}</Text>
              </Col>
              <Col>
                <Text strong>CP ID: </Text>
                <Text>{searchParams.get("cpId")}</Text>
              </Col>
              <Col>
                <Text strong>Date: </Text>
                <Text>{searchParams.get("date")}</Text>
              </Col>
            </Row>
          </Card>
        )}

        <Card>
          <Table
            columns={columns}
            dataSource={tableData}
            pagination={{
              current: pageNum,
              pageSize: pageSize,
              total: total,
              showSizeChanger: true,
              pageSizeOptions: ["50", "100", "200"],
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
            }}
            onChange={handlePageChange}
            rowKey={(record) => record.awb_number || Math.random()}
            scroll={{ x: "max-content" }}
          />
        </Card>
      </div>
    </Spin>
  );
};

export default DRSClickableDetail;
